import Collection from ".";

export const collectionRoute = (data) => [
  {
    path: "/admin/collections",
    title: "editor",
    layout: "admin",
    routeType: "admin",
    component: Collection,
  },
];
